{
  "en": {
    "common": {
      "email_address_status": {
        "spam_complaint_reactivation": "Spam complaints cannot be reactivated here. This can only be done manually via {link}.",
        "spam_complaint_reactivation_link": "Postmark"
      },
      "search": "Search",
      "selected": "Selected"
    }
  }
}
